import React from "react";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { AuthorSpotlightData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import styles from "./AuthorSpotlight.module.css";

export default function AuthorSpotlight() {
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_AUTHOR_MEMBERS_SPOTLIGHT
  );
  const apiData = response?.authorMembersSpotlight ?? AuthorSpotlightData;
  const navigate = useNavigate();
  return (
    <section className={styles.authors}>
      <div className={styles.container}>
        <h3>
          Research <span> Associates Members</span>
        </h3>
        <h5>Connect with leading researchers and their latest work</h5>
        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 3).map((t) => (
              <article className={styles.card} key={t.id}>
                <div className={styles.userDetails}>
                  <figure>
                    <img src={t.author.photograph} alt={t.author.full_name} />
                  </figure>
                  <div className={styles.content}>
                    <h6>{t.author.full_name}</h6>
                    <p title={`${t.author.current_designation} |  ${t.author.departmentFacultyName} | ${t.author.institution_name}, ${t.author.city}`}>
                      {t.author.current_designation} |  {t.author.departmentFacultyName} | {t.author.institution_name}, {t.author.city}
                    </p>

                  </div>
                </div>
                {/* <ul className={styles.tagContainer}>
                  {t.tags && t.tags.map((i) => <li key={i}>{i}</li>)}
                </ul> */}
                <div className={styles.details}>
                  {t.author.profileSummary?.length > 88
                    ? `${t.author.profileSummary.substring(0, 88)}...`
                    : t.author.profileSummary}
                </div>
                <div className={styles.tagOuter}>
                  <button
                    onClick={() => navigate(`/authors/${t.author.user_id}`)}
                  >
                    View Profile 
                  </button>
                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
